import React from 'react'
import DataWatcher from './data/DataWatcher.js';
import { useDispatch } from 'react-redux';
import { loadScan } from '../reducer/LaserDataSlice.js';
import { hideProcessing } from '../reducer/ProcessingSlice.js';

export default function DataImport(props) {
    const { onFileSelected, onLoaded } = props;
    const dispatch = useDispatch();

    const handleDownloaded = async(id, data) => {
        console.log("dataimport - handleDownloaded call loadScan");
        try
        {
            await dispatch(loadScan({
                id: id,
                scan: data})).unwrap();
    
            console.log("dataimport - handleDownloaded loadScan complete");
            if(onLoaded){
                console.log("dataimport - handleDownloaded call onLoaded");
                onLoaded();
            }
        }
        catch(e)
        {
            console.log(e);
            dispatch(hideProcessing());
        }
    }

    const handleDataAvailable = () => {
        if(onFileSelected) {
            onFileSelected();
        }
    }

    return (
        <DataWatcher
            onDataAvailable={handleDataAvailable}
            onDownloaded={handleDownloaded}
        />
    );
}
